// extracted by mini-css-extract-plugin
export default {"section":"ContactOptions_section__JPu37","label":"ContactOptions_label__jw7pD","options":"ContactOptions_options__lkBSA"};